$(document).ready(function() {
    let tocListWrapper = $('[data-toc-list-wrapper]');
    let tocList = $('[data-toc]');
    let tocTrigger = $('[data-toc-trigger]');
    let firstItem = true;

    $('.single-boersen-brief p').each(function(index) {
        let $p = $(this);
        let $a = $p.find('a[id]:not([href])');

        if ($a.length) {
            tocList.append(`
                <li class="toc__list-item">
                    <a href="#${$a[0].id}" data-text="${$p.text()}" class="${firstItem ? 'is-active' : ''}">${$p.text()}</a>
                </li>
            `);
            firstItem = false;
        }
    });

    tocTrigger.click(function() {
        $(this).toggleClass('is-active');
        tocListWrapper.toggleClass('is-active');
    });

    $(document).click(function(event) {
        // Check if the click was outside the tocListWrapper and tocTrigger
        if (!tocListWrapper.is(event.target) && tocListWrapper.has(event.target).length === 0 &&
            !tocTrigger.is(event.target) && tocTrigger.has(event.target).length === 0) {
            // Remove the is-active class if the click was outside
            tocListWrapper.removeClass('is-active');
            tocTrigger.removeClass('is-active');
        }
    });
});

$(window).on('resize scroll', function() {
    $('a[id]:not([href])').each(function() {
        let activeAnchor = $(this).attr('id');
        let itemAlreadyActive = false;

        if ($(this).isInViewport()) {
            if(!itemAlreadyActive) {
                $(`a[href="#${activeAnchor}"]`).addClass('is-active');
            }
            itemAlreadyActive = true;
        } else {
            $(`a[href="#${activeAnchor}"]`).removeClass('is-active');
            itemAlreadyActive = false;
        }
    });
});

$.fn.isInViewport = function() {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
